import React, { useState, useContext } from 'react';
import { getLastDayToRegister } from '../../../../components/exl/BookingHelperFunctions';
import { courseCategoryOptions, courseLanguageOptions, courseStatusOptions, translateOptionValue, courseFormatOptions } from '../../../../components/exl/shared/translations';
import InfoSection from './info-section';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { getIcon } from '../../../../components/crm/shared/field_inputs/shared/FormatHelpers';
import { useTranslation } from 'react-i18next';
import { DataContext as CovDataStore } from '../../../../store';
import { GENERAL_COURSE_INFO_ADDRESS_LABEL, COPIED_TO_CLIPBOARD, GENERAL_COURSE_INFO_CATEGORY_LABEL, GENERAL_COURSE_INFO_COURSE_DATE_LABEL, GENERAL_COURSE_INFO_LANGUAGE_LABEL, GENERAL_COURSE_INFO_LECTURE_TYPE_LABEL, GENERAL_COURSE_INFO_COURSE_LENGTH_LABEL, GENERAL_COURSE_INFO_STATUS_LABEL, DAY, DAYS, GENERAL_COURSE_INFO_FINAL_ENROLLMENT_DATE_LABEL, GENERAL_COURSE_INFO_MAX_NUM_PART_LABEL, GENERAL_COURSE_INFO_MAX_NUM_RES_LABEL, GENERAL_COURSE_INFO_NO_SET_ADDRESS, GENERAL_COURSE_INFO_NO_SET_COURSE_DATE, GENERAL_COURSE_INFO_NO_SET_COURSE_LENGTH, GENERAL_COURSE_INFO_NO_SET_FINAL_ENROLLMENT_DATE, GENERAL_COURSE_INFO_TEACHER_LABEL, WEEK, WEEKS, GENERAL_COURSE_INFO_MEETING_LINK_LABEL, GENERAL_COURSE_INFO_NO_SET_MEETING_LINK, GENERAL_COURSE_INFO_TRAVEL_SUPPLEMENT_LABEL, GENERAL_COURSE_INFO_PRICE_LABEL } from '../../../../i18n/keyConstants';


const getCourseDateDisplay = (startDate, endDate) => {

    moment.locale(localStorage.getItem('userLocale'));
    let formattedStartDate = startDate ? moment.utc(startDate).local().format('YYYY-MM-DD') : '';
    let formattedEndDate = endDate ? moment(endDate).local().format('YYYY-MM-DD') : '';

    let startDateMonth = formattedStartDate ? moment(formattedStartDate).format('MMMM') : '';
    startDateMonth = startDateMonth.charAt(0).toUpperCase() + startDateMonth.slice(1);

    let endDateMonth = formattedEndDate ? moment(formattedEndDate).format('MMMM') : '';
    endDateMonth = endDateMonth.charAt(0).toUpperCase() + endDateMonth.slice(1);

    let totalLengthInWeeks = formattedStartDate && formattedEndDate ? moment(formattedEndDate).diff(moment(formattedStartDate), 'weeks') : '';

    let totalLengthInDays = formattedStartDate && formattedEndDate ? moment(formattedEndDate).diff(moment(formattedStartDate), 'days') + 1 : '';

    let startYear = formattedStartDate ? moment(formattedStartDate).format('YYYY') : '';
    let endYear = formattedEndDate ? moment(formattedEndDate).format('YYYY') : '';

    if (startDate === null || endDate === null) {
        return null;
    }

    return {
        startDateDay: formattedStartDate ? moment(formattedStartDate).format('DD') : '',
        startDateMonth: startDateMonth,
        endDateDay: formattedEndDate ? moment(formattedEndDate).format('DD') : '',
        endDateMonth: endDateMonth,
        startDate: formattedStartDate ? moment(formattedStartDate).format('YYYY-MM-DD') : '',
        endDate: formattedEndDate ? moment(formattedEndDate).format('YYYY-MM-DD') : '',
        totalLengthInWeeks: totalLengthInWeeks,
        totalLengthInDays: totalLengthInDays,
        startYear: startYear,
        endYear: endYear,
    };
}


export default function GeneralCourseInformation({ course, courseUser }) {
    const { store: covStore } = useContext(CovDataStore);
    const user = covStore?.user;
    const {
        teachers,
        startDate,
        endDate,
        status,
        category,
        language,
        maxNumBookings,
        maxNumReserves,
        meetingLink,
        price,
        travelSupplement
    } = course;

    function truncateUrl(url, maxLength) {
        if (url.length <= maxLength) {
            return url;
        }
        const truncatedUrl = url.substring(0, maxLength - 3) + '...';
        return truncatedUrl;
    }

    const [copySuccess, setCopySuccess] = useState('');
    const [currentIcon, setCurrentIcon] = useState('clipboard');
    const { t } = useTranslation(['generalCourseInformation', 'shared']);


    let meetingLinkDisplay = null;
    let meetingLinkRights = false;

    const formattedDates = getCourseDateDisplay(startDate, endDate);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setCopySuccess(t(COPIED_TO_CLIPBOARD, { ns: 'shared' }));
        setCurrentIcon('clipboard-check');
        setTimeout(() => { setCopySuccess(''); setCurrentIcon('clipboard'); }, 3000);
    };


    function meetingLinkDisplayLogic() {
        if (meetingLink && meetingLink.trim().length > 0) {
            meetingLinkDisplay = meetingLink;
        }

        if ((course.courseFormat === 0 || course.courseFormat === 2) && (courseUser.editPermission || courseUser.teacherPermission || (courseUser.booking && [0, 3, 4, 5].includes(courseUser.booking.status)))) {
            meetingLinkRights = true;
        }
    }

    meetingLinkDisplayLogic();

    return (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_TEACHER_LABEL)}>
                {teachers.map((teacher) => (
                    <div key={teacher.id}>
                        <a href={`/exlTeacherDetails/${teacher?.id}`}>{teacher.name}</a>
                    </div>

                ))}
                {teachers.length < 1 && '-'}
            </InfoSection>

            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_COURSE_DATE_LABEL)}>
                {formattedDates !== null ? (
                    <>
                        {formattedDates.startDate === formattedDates.endDate ? (
                            <>
                                {formattedDates.startDateDay} {formattedDates.startDateMonth} {formattedDates.startYear}
                            </>
                        ) : (formattedDates.startDateMonth === formattedDates.endDateMonth && formattedDates.startYear === formattedDates.endYear) ? (
                            <>
                                {formattedDates.startDateDay} - {formattedDates.endDateDay} {formattedDates.startDateMonth} {formattedDates.startYear}
                            </>
                        ) : formattedDates.startYear === formattedDates.endYear ? (
                            <>
                                {formattedDates.startDateDay} {formattedDates.startDateMonth} - {formattedDates.endDateDay} {formattedDates.endDateMonth} {formattedDates.startYear}
                            </>
                        ) : (
                            <>
                                {formattedDates.startDateDay} {formattedDates.startDateMonth} {formattedDates.startYear} - {formattedDates.endDateDay} {formattedDates.endDateMonth} {formattedDates.endYear}
                            </>
                        )}

                    </>
                ) : (
                    <>
                        <span style={{ opacity: 0.6 }}> {t(GENERAL_COURSE_INFO_NO_SET_COURSE_DATE)} </span>
                    </>
                )
                }
            </InfoSection>

            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_FINAL_ENROLLMENT_DATE_LABEL)}>
                {getLastDayToRegister(course) || <span style={{ opacity: 0.6 }}>{t(GENERAL_COURSE_INFO_NO_SET_FINAL_ENROLLMENT_DATE)} </span>}
            </InfoSection>
            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_STATUS_LABEL)}>
                {t(translateOptionValue(status, courseStatusOptions), { ns: 'shared' })}
            </InfoSection>
            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_CATEGORY_LABEL)}>
                {t(translateOptionValue(category, courseCategoryOptions), { ns: 'shared' })}
            </InfoSection>
            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_LANGUAGE_LABEL)}>
                {t(translateOptionValue(language, courseLanguageOptions), { ns: 'shared' })}
            </InfoSection>
            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_LECTURE_TYPE_LABEL)}>
                {t(translateOptionValue(course.courseFormat, courseFormatOptions), { ns: 'shared' })}
            </InfoSection>
            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_MAX_NUM_PART_LABEL)}>
                {maxNumBookings}
            </InfoSection>
            <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_MAX_NUM_RES_LABEL)}>
                {maxNumReserves}
            </InfoSection>

            {(course.courseFormat === 1 || course.courseFormat === 2) && (
                <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_ADDRESS_LABEL)}>
                    {course.location ? course.location : <span style={{ opacity: 0.6 }}>{t(GENERAL_COURSE_INFO_NO_SET_ADDRESS)}</span>}
                </InfoSection>
            )}

            {(meetingLinkRights) && (
                <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_MEETING_LINK_LABEL)}>
                    {meetingLinkDisplay ?
                        <div>
                            <a href={meetingLinkDisplay.startsWith('http://') || meetingLinkDisplay.startsWith('https://') ? meetingLinkDisplay : `https://${meetingLinkDisplay}`}
                                target="_blank"
                                rel="noopener noreferrer">
                                {truncateUrl(meetingLinkDisplay, 30)}
                            </a>
                            <Button onClick={() => copyToClipboard(meetingLinkDisplay)} style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '5px 5px', border: 'none', color: 'black', outline: 'none', boxShadow: 'none', ':focus': { outline: 'none', border: 'none' } }}>
                                {getIcon(currentIcon)}
                            </Button>
                            <span style={{ position: 'absolute', right: '15', opacity: 0.6, paddingLeft: '5px' }}>{copySuccess}</span>
                        </div>
                        :
                        <div>
                            <span style={{ opacity: 0.6 }}>{t(GENERAL_COURSE_INFO_NO_SET_MEETING_LINK)}</span>
                        </div>
                    }
                </InfoSection>
            )}
            {(user.isExlAdmin) && (
                <>
                    {(price !== 0) && (
                        <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_PRICE_LABEL)}>
                            {price}
                        </InfoSection>
                    )}
                    {(travelSupplement !== 0) && (
                        <InfoSection sectionLabel={t(GENERAL_COURSE_INFO_TRAVEL_SUPPLEMENT_LABEL)}>
                            {travelSupplement}
                        </InfoSection>
                    )}
                </>
            )}
        </div>
    )
}